import React, { Component, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import {
  getAccountList,
  setSelectedAccount,
} from '../../actions/rldToolActions';
import CommonDropdown from '../../components/common/CommonDropdown';

const RldAccount = props => {
  //initialize the variables from redux
  const { accounts, selectedAccount } = useSelector(
    ({ rldTool }) => rldTool.account
  );

  //initialize the data from states
  const [placeHolder, setplaceHolder] = useState('Loading...');
  const [isFirstTimeLoad, setisFirstTimeLoad] = useState(true);  
  const dispatch = useDispatch();

  //get teh data
  useEffect(() => {
    if ((accounts.length == 0) || isFirstTimeLoad) {
      const sq = {
        all: 'true',
      };

      setisFirstTimeLoad(false);
      const userDefaultAccountID = props.userAccountID;

      dispatch(getAccountList(sq, userDefaultAccountID)).then(result => {
        result
          ? setplaceHolder('Search account...')
          : setplaceHolder('No Accounts');         
      });
    }
  }, [accounts]);

  //select an account
  const accountItemClick = e => {
    dispatch(setSelectedAccount(e));
  };

  return (
    <div> 
       <div className="account_component">
        <div className="account_control">
          <div className="account_selector">
            <div className="account_item"> 
              <CommonDropdown
                listData={accounts}
                defaultSelected={Object.entries(selectedAccount).length === 0 && selectedAccount.constructor === Object ? null: selectedAccount}
                itemClickFn={accountItemClick}
                filterSearch={true}
                placeHolder={placeHolder}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

RldAccount.propTypes = {
  userAccountID: PropTypes.number.isRequired,
};

export default RldAccount;
